<template>
  <v-row justify="center" align="center">
    <v-col cols="12" class="py-0">
      <v-alert class="text-left" border="left" text type="info">
        These are the postcodes in your system which home delivery customers can
        be registered with.
        <br />
        The days of the week shown below are the available delivery days
        per-postcode, these will only be taken into account if you have the 'Use
        Postcode Delivery Days' option enabled.
        <br />
        Currently this is
        <b>
          {{
            $store.getters.retrievePostcodeDeliveryDays ? "Enabled" : "Disabled"
          }}
        </b>
      </v-alert>
    </v-col>

    <v-col cols="12">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :search="search"
        :loading="$store.getters.postcodesLoading"
        :headers="headers"
        :items="$store.getters.retrievePostcodes"
        hide-default-footer
        disable-pagination
        class="elevation-0"
        @click:row="clickedRow"
        loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.DeliverOnSunday`]="{ item, value }">
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'success' : 'grey'
            "
            v-if="value == '1'"
          >
            check_circle_outline
          </v-icon>
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'error' : 'grey'
            "
            v-else
            >cancel</v-icon
          >
        </template>

        <template v-slot:[`item.DeliverOnMonday`]="{ item, value }">
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'success' : 'grey'
            "
            v-if="value == '1'"
          >
            check_circle_outline
          </v-icon>
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'error' : 'grey'
            "
            v-else
            >cancel</v-icon
          >
        </template>

        <template v-slot:[`item.DeliverOnTuesday`]="{ item, value }">
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'success' : 'grey'
            "
            v-if="value == '1'"
          >
            check_circle_outline
          </v-icon>
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'error' : 'grey'
            "
            v-else
            >cancel</v-icon
          >
        </template>

        <template v-slot:[`item.DeliverOnWednesday`]="{ item, value }">
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'success' : 'grey'
            "
            v-if="value == '1'"
          >
            check_circle_outline
          </v-icon>
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'error' : 'grey'
            "
            v-else
            >cancel</v-icon
          >
        </template>

        <template v-slot:[`item.DeliverOnThursday`]="{ item, value }">
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'success' : 'grey'
            "
            v-if="value == '1'"
          >
            check_circle_outline
          </v-icon>
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'error' : 'grey'
            "
            v-else
            >cancel</v-icon
          >
        </template>

        <template v-slot:[`item.DeliverOnFriday`]="{ item, value }">
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'success' : 'grey'
            "
            v-if="value == '1'"
          >
            check_circle_outline
          </v-icon>
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'error' : 'grey'
            "
            v-else
            >cancel</v-icon
          >
        </template>

        <template v-slot:[`item.DeliverOnSaturday`]="{ item, value }">
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'success' : 'grey'
            "
            v-if="value == '1'"
          >
            check_circle_outline
          </v-icon>
          <v-icon
            :color="
              $store.getters.retrievePostcodeDeliveryDays ? 'error' : 'grey'
            "
            v-else
            >cancel</v-icon
          >
        </template>

        <template v-slot:no-data>
          <span class="subtitle-2 font-weight-medium">
            No Postcodes Data Found
          </span>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <h4>Edit Postcode</h4>
          <v-spacer></v-spacer>
          <v-btn icon color text @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-form ref="PostcodesForm" @submit.prevent v-model="valid">
          <v-card-text>
            <v-alert class="text-left" text type="info">
              Postcode:
              <b>
                {{ this.amend_postcode }}
              </b>
            </v-alert>

            <v-switch
              v-model="amend_DeliverOnSunday"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Deliver On Sunday
                <v-icon
                  right
                  :color="amend_DeliverOnSunday ? 'success' : 'error'"
                >
                  {{
                    amend_DeliverOnSunday ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>

            <v-switch
              v-model="amend_DeliverOnMonday"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Deliver On Monday
                <v-icon
                  right
                  :color="amend_DeliverOnMonday ? 'success' : 'error'"
                >
                  {{
                    amend_DeliverOnMonday ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>

            <v-switch
              v-model="amend_DeliverOnTuesday"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Deliver On Tuesday
                <v-icon
                  right
                  :color="amend_DeliverOnTuesday ? 'success' : 'error'"
                >
                  {{
                    amend_DeliverOnTuesday ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>

            <v-switch
              v-model="amend_DeliverOnWednesday"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Deliver On Wednesday
                <v-icon
                  right
                  :color="amend_DeliverOnWednesday ? 'success' : 'error'"
                >
                  {{
                    amend_DeliverOnWednesday ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>

            <v-switch
              v-model="amend_DeliverOnThursday"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Deliver On Thursday
                <v-icon
                  right
                  :color="amend_DeliverOnThursday ? 'success' : 'error'"
                >
                  {{
                    amend_DeliverOnThursday ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>

            <v-switch
              v-model="amend_DeliverOnFriday"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Deliver On Friday
                <v-icon
                  right
                  :color="amend_DeliverOnFriday ? 'success' : 'error'"
                >
                  {{
                    amend_DeliverOnFriday ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>

            <v-switch
              v-model="amend_DeliverOnSaturday"
              color="blue darken-2"
              inset
            >
              <template v-slot:label>
                Deliver On Saturday
                <v-icon
                  right
                  :color="amend_DeliverOnSaturday ? 'success' : 'error'"
                >
                  {{
                    amend_DeliverOnSaturday ? "check_circle_outline" : "cancel"
                  }}
                </v-icon>
              </template>
            </v-switch>
          </v-card-text>
          <v-card-actions class="dialogActions">
            <v-btn
              large
              type="submit"
              :loading="$store.getters.postcodesLoading"
              color="error"
              @click="deleteRow"
              outlined
            >
              Delete
            </v-btn>
            <v-spacer />
            <v-btn
              large
              type="submit"
              :loading="$store.getters.postcodesLoading"
              color="blue darken-2"
              @click="amendRow"
              outlined
              :disabled="!valid"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ViewDeliveryPostcodes",

  components: {},

  data: () => {
    return {
      dialog: false,
      valid: false,

      search: null,

      headers: [
        { text: "Postcode", value: "postcode" },
        { text: "Sunday", value: "DeliverOnSunday" },
        { text: "Monday", value: "DeliverOnMonday" },
        { text: "Tuesday", value: "DeliverOnTuesday" },
        { text: "Wednesday", value: "DeliverOnWednesday" },
        { text: "Thursday", value: "DeliverOnThursday" },
        { text: "Friday", value: "DeliverOnFriday" },
        { text: "Saturday", value: "DeliverOnSaturday" },
      ],

      amend_id: null,
      amend_postcode: null,
      amend_DeliverOnSunday: true,
      amend_DeliverOnMonday: true,
      amend_DeliverOnTuesday: true,
      amend_DeliverOnWednesday: true,
      amend_DeliverOnThursday: true,
      amend_DeliverOnFriday: true,
      amend_DeliverOnSaturday: true,
    };
  },

  activated() {
    this.getAllPostcodes();
  },

  computed: {},

  methods: {
    ...mapActions(["getAllPostcodes", "updatePostcode", "deletePostcode"]),

    clickedRow(item) {
      console.log("ROW ITEM");
      console.log(item);
      console.log(Boolean(parseInt(item.DeliverOnSunday)));
      this.dialog = true;

      this.amend_id = item.id;
      this.amend_postcode = item.postcode;
      this.amend_DeliverOnSunday = Boolean(parseInt(item.DeliverOnSunday));
      this.amend_DeliverOnMonday = Boolean(parseInt(item.DeliverOnMonday));
      this.amend_DeliverOnTuesday = Boolean(parseInt(item.DeliverOnTuesday));
      this.amend_DeliverOnWednesday = Boolean(
        parseInt(item.DeliverOnWednesday)
      );
      this.amend_DeliverOnThursday = Boolean(parseInt(item.DeliverOnThursday));
      this.amend_DeliverOnFriday = Boolean(parseInt(item.DeliverOnFriday));
      this.amend_DeliverOnSaturday = Boolean(parseInt(item.DeliverOnSaturday));
    },

    async amendRow() {
      console.log("Amend Row");

      let data = {
        id: this.amend_id,
        DeliverOnSunday: this.amend_DeliverOnSunday ? 1 : 0,
        DeliverOnMonday: this.amend_DeliverOnMonday ? 1 : 0,
        DeliverOnTuesday: this.amend_DeliverOnTuesday ? 1 : 0,
        DeliverOnWednesday: this.amend_DeliverOnWednesday ? 1 : 0,
        DeliverOnThursday: this.amend_DeliverOnThursday ? 1 : 0,
        DeliverOnFriday: this.amend_DeliverOnFriday ? 1 : 0,
        DeliverOnSaturday: this.amend_DeliverOnSaturday ? 1 : 0,
      };

      let result = await this.updatePostcode(data);
      if (result) {
        this.dialog = false;
      }
    },

    async deleteRow() {
      let result = await this.deletePostcode(this.amend_id);
      if (result) {
        this.dialog = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>